'use client';

import { useEffect,useState } from 'react';
import Request from './requestPermission'; // Adjust path if needed
import { useSelector } from 'react-redux';
import axios from 'axios'
import {KeyUri} from '../key'

const NotificationInit = () => {
  const { token, user } = useSelector((state) => state.userauth); 
  const [retrievedData] = useState(() =>
    JSON.parse(localStorage.getItem("userID"))
  );
  useEffect(() => {
    const initFCM = async () => {
      try {
        const token = await Request();
        if (token) {
          console.log('🎯 FCM Token:', token, retrievedData);
          // Optional: send token to your backend here
          await axios.post(
            `${KeyUri.BACKEND_URI}/createfcm`,
            {
              token: token,
              user: retrievedData,
            },
          );

          console.log('✅ FCM token saved to backend');
        } else {
          console.warn('⚠️ FCM Token not retrieved');
        }
      } catch (err) {
        console.error('❌ Error initializing FCM:', err);
      }
    };

    initFCM();
    if (token && user) {
      initFCM();
    }
  }, [token, user]);

  return null; // or return some loading state if needed
};

export default NotificationInit;
